// Keeps the outlined tooltip inside the viewport when its trigger sits close to a screen edge.
// The box is anchored to the trigger in CSS, this only adds the horizontal correction as
// --tooltip-shift, which custom.css.liquid applies to the box and counters on the arrow.
class TooltipOutlined extends HTMLElement {
  static VIEWPORT_MARGIN = 16;
  static ARROW_INSET = 26;

  constructor() {
    super();
    this.reposition = this.reposition.bind(this);
  }
  connectedCallback() {
    this.tooltip = this.querySelector(".tooltip--outlined");
    if (!this.tooltip) return;

    this.addEventListener("mouseenter", this.reposition);
    this.addEventListener("focusin", this.reposition);
  }
  reposition() {
    // The box has no dimensions while display:none, so force layout to measure it: visibility
    // keeps it invisible, and the shift is reset because its transform is part of the measurement.
    const display = this.tooltip.style.display;
    const visibility = this.tooltip.style.visibility;
    this.setShift(0);
    this.tooltip.style.display = "block";
    this.tooltip.style.visibility = "hidden";
    const rect = this.tooltip.getBoundingClientRect();
    this.tooltip.style.display = display;
    this.tooltip.style.visibility = visibility;

    let shift = 0;
    if (rect.left < TooltipOutlined.VIEWPORT_MARGIN) {
      shift = TooltipOutlined.VIEWPORT_MARGIN - rect.left;
    } else if (rect.right > window.innerWidth - TooltipOutlined.VIEWPORT_MARGIN) {
      shift = window.innerWidth - TooltipOutlined.VIEWPORT_MARGIN - rect.right;
    }

    // Never shift so far that the arrow leaves the box
    const maxShift = Math.max(rect.width - TooltipOutlined.ARROW_INSET, 0);
    this.setShift(Math.max(Math.min(shift, maxShift), -maxShift));
  }
  setShift(shift) {
    this.tooltip.style.setProperty("--tooltip-shift", `${Math.round(shift)}px`);
  }
}

customElements.define("tooltip-outlined", TooltipOutlined);